export default "__VITE_ASSET__CyLUWBZu__"